<template>
    <div id="app">
        <router-view></router-view>
        <!--        <div style="height:1rem;">-->
        <van-tabbar  route active-color="#00ACEF" style="z-index: 999;height: 50px" v-show="isTabShow&&isShow" >
            <van-tabbar-item replace :to="item.route"  v-for="item in tabs">
                <div class="tab-name" :class="{'active': tabActive==item.active}">
                    <van-icon :class="'iconfont '+ item.tbIcon" size="20" style="color: #2b94ff;display: block"/>
                    <span style="display: block">{{item.styleName}}</span>
                </div>
            </van-tabbar-item >
        </van-tabbar>
    </div>
</template>
<script>
    import TabBar from "./views/components/TabBar"
    import TabBarItem from "./views/components/TabBarItem"
    import {getDeptId} from "./utils/auth";
    import "@/assets/icon/iconfont.css";

    export default {
        data() {
            return {
                ws: null,
                isTabShow: false,
                isShow: false,
                did: '',
                active:'',
                tabs:[],
                tabActive:'',
                path:'',
            }
        },
        components: {
            TabBar,
            TabBarItem,
        },
        async created() {
          this.did = getDeptId()
          await this.getSpmTabbarList()
          this.setTabbar()
          let name = this.$route.name
          this.tabActive=name
        },
        watch: {
            "$route": function (to) {
                this.path=to.path
                this.setTabbar()
            }
        },
        methods: {
            async getSpmTabbarList() {
                if (!this.did){
                    return ;
                }
                let data = {
                    deptId: this.did,
                }
                let res = await this.$get("/spm/getSpmTabbarList", data)
                this.tabs = res.list
                this.$nextTick(() => {
                    if (this.tabs.length>0){
                        this.isShow=true
                    }
                });
            },
            setTabbar(){
                var tabArr = [];
                this.tabs.forEach(item=>{
                    tabArr.push(item.route)
                })
                if (tabArr.includes(this.path)) {
                    let arr =this.path.split('/')
                    this.tabActive ='/'+arr[1]
                    this.isTabShow = true
                } else {
                    this.isTabShow = false
                }
            },
        },
        computed: {}
    }
</script>

<style lang="scss">
    body,
    html {
        height: 100%;
    }

    #app {
        font-family: "PingFang SC", "微软雅黑", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100%;
    }

    .form-container .cube-radio-group {
        padding: 10px 50px;
        border-bottom: 1px #d1d1d1 solid;
    }

    .form-container .cube-radio {
        width: 50%;
        box-sizing: border-box;
        display: inline-block;
    }

    .form-container .cube-radio:first-child {
        border-right: 1px #ccc solid
    }

    .form-container .cube-radio-wrap {
        padding: 4px 0
    }

    input:focus {
        outline: none;
    }

    .border-bottom-1px::after {
        border: none
    }

    ::v-deep .van-tabbar {
        z-index: 1;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: content-box;
        width: 100%;
        height: 1.33333rem;
        background-color: #fff;
    }
    .tab-name{
        height: 43px;
        padding-top: 7px;
    }
    .iconfont{
        text-align: center;
        margin-bottom: 3px;
    }

    .active{
        color: #2b94ff;
    }

</style>
